<div class="content-container">
    <div class="container">
        <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="personsPerSquareMeterComponent?.overrideDefaultValue"
            (ngModelChange)="personsPerSquareMeterComponent.overrideDefaultValue = $event" class="margin-right form-field">
            Override default value
        </mat-checkbox>
        <mat-form-field appearance="outline" class="form-field"
            *ngIf="personsPerSquareMeterComponent.overrideDefaultValue">
            <mat-label>Number of people per m<sup>2</sup></mat-label>
            <input matInput type="number" step="0.5" [ngModel]="personsPerSquareMeterComponent?.amountOfPeople"
                (ngModelChange)="personsPerSquareMeterComponent.amountOfPeople = $event" autocomplete="off">
        </mat-form-field>
    </div>
</div>